/**
 * Staffing Command Center - Application Entry Point
 * Built and maintained by Angel Carreon (acarreom)
 * Copyright © 2025. All rights reserved.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import AppRouter from './components/AppRouter';
import NetworkAuthWrapper from './components/MidwayAuthWrapper';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <NetworkAuthWrapper>
        {(props) => <AppRouter {...props} />}
      </NetworkAuthWrapper>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
